import 'Utils/responsiveHelper';

export default function initBlockMovement() {
	jQuery('.carousel-block').each(function() {
		const holder = jQuery(this);

		responsiveBlock({
			block: holder.find('[movement-item]'),
			ranges: {
				'0..767': holder.find('[mobile-holder]'),
				'768..': holder.find('[tablet-holder]')
			}
		});
	});

	jQuery('.section-floorplans').each(function() {
		const holder = jQuery(this);

		responsiveBlock({
			block: holder.find('[movement-item]'),
			ranges: {
				'0..767': holder.find('[mobile-holder]'),
				'768..1023': holder.find('[tablet-holder]'),
				'1024..': holder.find('[desktop-holder]')
			}
		});
	});

	jQuery('.resource-article').each(function() {
		const holder = jQuery(this);

		responsiveBlock({
			block: holder.find('[movement-item]'),
			ranges: {
				'0..1023': holder.find('[mobile-holder]'),
				'1024..': holder.find('[desktop-holder]')
			}
		});
	});

	jQuery('.stacked-photo').each(function() {
		const holder = jQuery(this);

		responsiveBlock({
			block: holder.find('[movement-item]'),
			ranges: {
				'0..1023': holder.find('[mobile-holder]'),
				'1024..': holder.find('[desktop-holder]')
			}
		});
	});

	jQuery('.hero-section').each(function() {
		const holder = jQuery(this);

		responsiveBlock({
			block: holder.find('[movement-item]'),
			ranges: {
				'0..1023': holder.find('[mobile-holder]'),
				'1024..': holder.find('[desktop-holder]')
			}
		});
	});

	jQuery('.floorplan-section').each(function() {
		const holder = jQuery(this);

		responsiveBlock({
			block: holder.find('[movement-item]'),
			ranges: {
				'0..767': holder.find('[mobile-holder]'),
				'768..1023': holder.find('[tablet-holder]'),
				'1024..': holder.find('[mobile-holder]')
			}
		});
	});

	jQuery('.finder-section').each(function() {
		const holder = jQuery(this);

		responsiveBlock({
			block: holder.find('[movement-item]'),
			ranges: {
				'0..767': holder.find('[mobile-holder]'),
				'768..': holder.find('[tablet-holder]')
			}
		});
	});

	jQuery('.section-resource').each(function() {
		const holder = jQuery(this);

		responsiveBlock({
			block: holder.find('[movement-item]'),
			ranges: {
				'0..767': holder.find('[mobile-holder]'),
				'768..': holder.find('[tablet-holder]')
			}
		});
	});
}

function responsiveBlock(options) {
	var block = options.block;
	var range = options.ranges;
	var breakpoints = {};

	jQuery.each(range, function(key, elem) {
		breakpoints[key] = {
			on: function() {
				block.appendTo(elem);
			}
		};
	});

	ResponsiveHelper.addRange(breakpoints);
}